import { render, staticRenderFns } from "./LoginPersonalizeLocalModal.vue?vue&type=template&id=b4dc949c&scoped=true"
import script from "./LoginPersonalizeLocalModal.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizeLocalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dc949c",
  null
  
)

export default component.exports